import { Metamodel } from 'app/model/base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { FabricSqlTableDataset } from 'shell-models-lib';
import { SqlServerSink } from './sql-server.copysink';

@Metamodel.model({
    name: adfModelTypeMap.fabricSql.copySinkType,
    display: [],
    referable: true,
    tags: { datasetModel: Metamodel.modelFor(FabricSqlTableDataset) }
})
export class FabricSqlCopySink extends SqlServerSink {}
